<ng-container *ngIf="OnlineState$ | async as state">
    <div class="clearfix display-flex align-items-baseline flex-column lg:flex-row">
        <div class="mr-2 mb-2 md:hidden" style="text-align: left; float: left">
            <mat-button-toggle
                    [checked]="withArchiveState"
                    (change)="withArchiveState = $event.source.checked; handleArchiveState($event)"
                    style="width: 250px">
                <i class="fa mr-2" [class.fa-check-square]="withArchiveState" [class.fa-square]="!withArchiveState"></i>
                {{ 'txTeamLeaderProtocol.archivedEntries' | translate }}
            </mat-button-toggle>
        </div>

        <mat-form-field appearance="outline" class="full-width search-input">
            <mat-button-toggle
                    matPrefix
                    class="mr-2 hidden md:block"
                    [checked]="withArchiveState"
                    (change)="withArchiveState = $event.source.checked; handleArchiveState($event)"
                    style="width: 250px">
                <i class="fa mr-2" [class.fa-check-square]="withArchiveState" [class.fa-square]="!withArchiveState"></i>
                {{ 'txTeamLeaderProtocol.archivedEntries' | translate }}
            </mat-button-toggle>
            <mat-label>{{ 'txTeamLeaderProtocol.search' | translate }}</mat-label>
            <input type="text" matInput [(ngModel)]="filterValue" (input)="applyFilter(filterValue)"/>
            <div matSuffix>
                <mat-icon>search</mat-icon>
            </div>
        </mat-form-field>
    </div>

    <div class="table-scroll">
    <table mat-table [dataSource]="dataSource" matSort class="w-full table">
        <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef style="width: 5%"></th>
            <td mat-cell *matCellDef="let rowData" style="width: 5%">
                <mat-checkbox
                        (click)="$event.stopPropagation()"
                        (change)="$event ? toggleRow(rowData) : null"
                        [checked]="selection.isSelected(rowData)">
                </mat-checkbox>
            </td>
        </ng-container>

        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 14%">
                {{ 'txTeamLeaderProtocol.name' | translate }}
            </th>
            <td mat-cell *matCellDef="let rowData">
                <ng-template [ngIf]="rowData.art == 'FSCHECK'">
                    <a *ngIf="state.isOnline && !isBusy[rowData.data_id]"
                       (click)="showDriverLicenseCheckDialog(rowData.data_id, rowData.personalnummer)">
                        <span [innerHTML]="rowData.name" style="text-decoration: underline"></span>
                    </a>
                    <span *ngIf="!state.isOnline || !!isBusy[rowData.data_id]"
                          [innerHTML]="rowData.name"
                          style="text-decoration: underline"></span>
                </ng-template>
                <ng-template [ngIf]="rowData.art != 'FSCHECK'">
                    <span [innerHTML]="rowData.name"></span>
                </ng-template>
            </td>
        </ng-container>

        <ng-container matColumnDef="datum">
            <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 13%">
                {{ 'txTeamLeaderProtocol.date' | translate }}
            </th>
            <td mat-cell *matCellDef="let rowData" style="white-space: nowrap">{{ rowData.datum }}</td>
        </ng-container>

        <ng-container matColumnDef="info">
            <th mat-header-cell *matHeaderCellDef style="width: 68%">{{ 'txTeamLeaderProtocol.info' | translate }}</th>
            <td mat-cell *matCellDef="let rowData"
                style="white-space: normal; word-wrap: break-word;"
                class="disabled-exact disabled-only-blur disabled-loading disabled-loading-small"
                [ngClass]="{ 'disabled-overlay': !!isBusy[rowData.data_id] }">
                <ng-template [ngIf]="rowData.art == 'FSCHECK'">
                    <a *ngIf="state.isOnline"
                       (click)="showDriverLicenseCheckDialog(rowData.data_id, rowData.personalnummer)">
                        <span [innerHTML]="rowData.protocoltext"></span><i class="fa fa-external-link" aria-hidden="true" style="margin-left: 8px"></i>
                    </a>
                    <span *ngIf="!state.isOnline" [innerHTML]="rowData.protocoltext"></span>
                </ng-template>
                <ng-template [ngIf]="rowData.art != 'FSCHECK'">
                    <span [innerHTML]="rowData.protocoltext"></span>
                </ng-template>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"
            [@rowVisibleState]="row.deleteState"
            [attr.data-art]="row.art"
            [style.background-color]="row.art == 'FSCHECK' ? 'rgba(255,0,0,0.1)' : ''"></tr>
    </table>
    </div>
    <mat-paginator [pageSize]="20" [pageSizeOptions]="[10, 20, 50]"></mat-paginator>

    <div *ngIf="driverLicenseCheck" class="tx-inline-dialog-backdrop" (click)="driverLicenseCheck = false">
        <mat-card class="tx-inline-dialog driver-license-check" (click)="$event.stopPropagation()">
            <mat-card-title>
                {{ 'txTeamleiter.driverLicenseCheck' | translate }}
                <button mat-icon-button (click)="driverLicenseCheck = false">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-card-title>
            <mat-card-content>
                <div class="grid p-5 xl:vw90" style="height: 100%">
                    <div class="col-12 md:col-6 flex align-items-center flex-direction-column">
                        <h4 class="font-weight-bold">{{ 'txTeamleiter.reference' | translate }}</h4>
                        <pdf-viewer
                                [src]="refBase64"
                                [original-size]="false"
                                [fit-to-page]="true"
                                [autoresize]="true"
                                [show-borders]="false"
                                [zoom-scale]="'page-fit'"
                                style="width: 100%; padding-bottom: 75%;"
                        ></pdf-viewer>
                    </div>
                    <div class="col-12 md:col-6 flex align-items-center flex-direction-column">
                        <h4 class="font-weight-bold">{{ 'txTeamleiter.employeeUpload' | translate }}</h4>
                        <object [attr.data]="userImage" type="application/pdf"
                                style="width:100%; aspect-ratio: 14/16; height: auto"></object>
                    </div>
                </div>
            </mat-card-content>
            <mat-card-actions class="flex justify-content-space-between align-items-center">
                <mat-form-field appearance="outline" class="w-full mr-2" style="margin-bottom: -22px">
                    <mat-label>{{ 'txTeamleiter.note' | translate }}</mat-label>
                    <input matInput [(ngModel)]="driverLicenseNotice" autocomplete="new-password"/>
                </mat-form-field>
                <div class="display-flex">
                    <button type="button" mat-raised-button color="primary"
                            (click)="confirmDriverLicenseCheck(1)" class="ui-button-success mr-2">
                        <i class="fa fa-check mr-2" aria-hidden="true"></i>
                        <span class="hidden md:inline">{{ 'general.confirm' | translate }}</span>
                    </button>
                    <button type="button" mat-raised-button color="warn"
                            (click)="confirmDriverLicenseCheck(0)" class="ui-button-danger">
                        <i class="fa fa-times mr-2" aria-hidden="true"></i>
                        <span class="hidden md:inline">{{ 'txTeamleiter.disagree' | translate }}</span>
                    </button>
                </div>
            </mat-card-actions>
        </mat-card>
    </div>
</ng-container>
